import cometpng from "./comet.png"
import { Sprite } from "pixi.js"
import { randomX } from './randomizeCometPosition'

let comets: any = []
let wasHere = false

export const randomWhiteComet = (stage: any, ticker: any) => {
    const timeUntilNextComet = Math.random() * 5000
    const outerTimeout = setTimeout(() => {
        const comet = Sprite.from(cometpng)
        comet.position.set(randomX(), 0)
        stage.addChild(comet)
        comets.push(comet)
        randomWhiteComet(stage, ticker)

        const innerTimeout = setTimeout(() => {
            stage.removeChild(comet)
            comets.shift(comet)
            clearTimeout(innerTimeout)
        }, 3000)

        clearTimeout(outerTimeout)
    }, timeUntilNextComet)

    if (!wasHere) {
        wasHere = true
        ticker.remove(cometsMoving, "cometsMoving")
        ticker.add(cometsMoving, 'cometsMoving')
    }
    function cometsMoving() {
        comets.forEach((c: any) => {
            c.position.x += 10 * (63 / 78)
            c.position.y += 10  // + speed / 10
        })
    }

}
